import successPayment from "../images/successPayment.svg";

const PaymentSuccess = () => {
  return (
    <div className="bg-white flex flex-col justify-center items-center min-h-screen">
      <div className="grid gap-10 justify-self-center px-10 md:px-0">
        <div></div>
        <div className="flex flex-col text-center gap-10">
          <div className="grid justify-center">
            <img
              className="w-32 h-32 md:w-44 md:h-44"
              src={successPayment}
              alt="noImg"
            />
          </div>
          <div>
            <div className="flex flex-col gap-2">
              <h1 className="text-xl md:text-4xl font-semibold">
                Payment Successful
              </h1>
              <p className="text-[#af9558] text-sm md:text-2xl">
                Thank you! Your payment was processed successfully.We'll update
                you shortly.
              </p>
            </div>
          </div>
          <div>
            <a href="/">
              <button className="border-0 w-full hover:border hover:border-[#b39143] hover:bg-white hover:text-[#b39143] bg-[#b39143] h-12 md:h-16 rounded-full text-white md:py-4 md:text-2xl">
                Go to homepage
              </button>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentSuccess;
